import styled from 'styled-components/macro';
import { Typography } from '@redis-ui/components';

export const ResetPasswordContainer = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  margin-bottom: 10rem;
`;

export const ResetPasswordFormTitle = styled(Typography.Heading)`
  color: ${({ theme }) =>
    theme.appComponents.login.components.resetPassword.resetPasswordFormTitle.color};
  margin-bottom: 2.4rem;
`;
